// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Header - Compact Professional Design
   ============================================ */

/* CSS Variables - Matching Sidebar Theme */
:root {
  --header-bg: #ffffff;
  --header-border: rgba(135, 206, 235, 0.3);
  --header-text: #000000;
  --header-text-muted: #4a5568;
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --header-transition: all 0.2s ease;
}

/* ============================================
   Main Header Container
   ============================================ */
.Header_header__5xukw {
  width: 100%;
  background: var(--header-bg);
  border-bottom: 1px solid var(--header-border);
  position: sticky;
  top: 0;
  z-index: 100;
}

.Header_headerContent__BNPlQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1.25rem;
  min-height: 60px;
  max-width: 100%;
  position: relative;
}

@media (max-width: 768px) {
  .Header_headerContent__BNPlQ {
    padding-left: 3.5rem; /* Space for mobile toggle button */
  }
}

/* ============================================
   Header Left Section
   ============================================ */
.Header_headerLeft__o3k6Y {
  display: flex;
  align-items: center;
  flex: 1 1;
}

.Header_headerTitle__u43YS {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--header-text);
  margin: 0;
  letter-spacing: -0.25px;
}

/* ============================================
   Header Right Section
   ============================================ */
.Header_headerRight__q1vdB {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  position: relative;
}

.Header_balancePill__ayAwY {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border: 1px solid var(--header-border);
  border-radius: 1.5rem;
  padding: 0.35rem 0.7rem;
  background: rgba(135, 206, 235, 0.08);
  color: var(--header-text);
}

.Header_balanceLabel__ToRBS {
  font-size: 0.75rem;
  color: var(--header-text-muted);
}

.Header_balanceValue__sWvBS {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--header-text);
}

/* ============================================
   Profile Button
   ============================================ */
.Header_profileButton__kp86u {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  background: transparent;
  border: 1px solid var(--header-border);
  border-radius: 1.5rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  transition: var(--header-transition);
  position: relative;
}

.Header_profileButton__kp86u:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
}

.Header_profileIcon__8PZya {
  color: var(--light-sky-blue);
  flex-shrink: 0;
}

.Header_chevronIcon__vlJcm {
  color: var(--header-text-muted);
  transition: transform 0.2s ease;
}

.Header_chevronOpen__Agx-T {
  transform: rotate(180deg);
}

/* ============================================
   Dropdown Menu
   ============================================ */
.Header_dropdown__xchyz {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: var(--header-bg);
  border: 1px solid var(--header-border);
  border-radius: 0.5rem;
  min-width: 200px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  animation: Header_slideDown__tuS3- 0.2s ease;
}

@keyframes Header_slideDown__tuS3- {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.Header_dropdownHeader__13Tpc {
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--header-border);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.Header_dropdownWelcome__8uW2T {
  font-size: 0.75rem;
  color: var(--header-text-muted);
  font-weight: 400;
}

.Header_dropdownRole__eeGKi {
  font-size: 0.875rem;
  color: var(--header-text);
  font-weight: 600;
  text-transform: capitalize;
}

.Header_dropdownDivider__0cGwh {
  height: 1px;
  background: var(--header-border);
  margin: 0.5rem 0;
}

.Header_logoutButton__A3\\+zb {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  color: var(--light-red);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--header-transition);
  text-align: left;
}

.Header_logoutButton__A3\\+zb:hover {
  background: rgba(255, 107, 107, 0.1);
  color: #ff5252;
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .Header_headerContent__BNPlQ {
    padding: 0.75rem 1rem;
    min-height: 55px;
  }

  .Header_headerTitle__u43YS {
    font-size: 1.125rem;
  }

  .Header_welcomeText__rTzny,
  .Header_roleText__7IZvf {
    font-size: 0.8125rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .Header_header__5xukw {
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .Header_headerContent__BNPlQ {
    padding: 0.625rem 0.875rem;
    min-height: 50px;
    flex-wrap: nowrap;
    gap: 0.5rem;
  }

  .Header_headerLeft__o3k6Y {
    flex: 1 1;
    min-width: 0;
    overflow: hidden;
  }

  .Header_headerTitle__u43YS {
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .Header_headerRight__q1vdB {
    position: relative;
    flex-shrink: 0;
  }

  .Header_balancePill__ayAwY {
    padding: 0.3rem 0.55rem;
  }

  .Header_balanceLabel__ToRBS {
    display: none;
  }

  .Header_dropdown__xchyz {
    min-width: 180px;
    right: 0;
    max-width: calc(100vw - 1rem);
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .Header_headerContent__BNPlQ {
    padding: 0.5rem 0.75rem;
    min-height: 48px;
  }

  .Header_headerTitle__u43YS {
    font-size: 1rem;
  }

  .Header_profileButton__kp86u {
    padding: 0.25rem 0.375rem;
  }

  .Header_profileIcon__8PZya {
    width: 28px;
    height: 28px;
  }

  .Header_chevronIcon__vlJcm {
    width: 14px;
    height: 14px;
  }

  .Header_balanceValue__sWvBS {
    font-size: 0.8125rem;
  }

  .Header_dropdown__xchyz {
    min-width: 160px;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
  }
}

/* Print styles */
@media print {
  .Header_header__5xukw {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/css/Header.module.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;iDAEiD;AACjD;EACE,WAAW;EACX,4BAA4B;EAC5B,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB,EAAE,mCAAmC;EAC3D;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,4CAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,oBAAoB;EACtB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,6BAA6B;EAC/B;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================\n   Header - Compact Professional Design\n   ============================================ */\n\n/* CSS Variables - Matching Sidebar Theme */\n:root {\n  --header-bg: #ffffff;\n  --header-border: rgba(135, 206, 235, 0.3);\n  --header-text: #000000;\n  --header-text-muted: #4a5568;\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --header-transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Header Container\n   ============================================ */\n.header {\n  width: 100%;\n  background: var(--header-bg);\n  border-bottom: 1px solid var(--header-border);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.headerContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.875rem 1.25rem;\n  min-height: 60px;\n  max-width: 100%;\n  position: relative;\n}\n\n@media (max-width: 768px) {\n  .headerContent {\n    padding-left: 3.5rem; /* Space for mobile toggle button */\n  }\n}\n\n/* ============================================\n   Header Left Section\n   ============================================ */\n.headerLeft {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.headerTitle {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--header-text);\n  margin: 0;\n  letter-spacing: -0.25px;\n}\n\n/* ============================================\n   Header Right Section\n   ============================================ */\n.headerRight {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.balancePill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  border: 1px solid var(--header-border);\n  border-radius: 1.5rem;\n  padding: 0.35rem 0.7rem;\n  background: rgba(135, 206, 235, 0.08);\n  color: var(--header-text);\n}\n\n.balanceLabel {\n  font-size: 0.75rem;\n  color: var(--header-text-muted);\n}\n\n.balanceValue {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--header-text);\n}\n\n/* ============================================\n   Profile Button\n   ============================================ */\n.profileButton {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  background: transparent;\n  border: 1px solid var(--header-border);\n  border-radius: 1.5rem;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  transition: var(--header-transition);\n  position: relative;\n}\n\n.profileButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n}\n\n.profileIcon {\n  color: var(--light-sky-blue);\n  flex-shrink: 0;\n}\n\n.chevronIcon {\n  color: var(--header-text-muted);\n  transition: transform 0.2s ease;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n/* ============================================\n   Dropdown Menu\n   ============================================ */\n.dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  background: var(--header-bg);\n  border: 1px solid var(--header-border);\n  border-radius: 0.5rem;\n  min-width: 200px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  animation: slideDown 0.2s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdownHeader {\n  padding: 0.875rem 1rem;\n  border-bottom: 1px solid var(--header-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.dropdownWelcome {\n  font-size: 0.75rem;\n  color: var(--header-text-muted);\n  font-weight: 400;\n}\n\n.dropdownRole {\n  font-size: 0.875rem;\n  color: var(--header-text);\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.dropdownDivider {\n  height: 1px;\n  background: var(--header-border);\n  margin: 0.5rem 0;\n}\n\n.logoutButton {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  color: var(--light-red);\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--header-transition);\n  text-align: left;\n}\n\n.logoutButton:hover {\n  background: rgba(255, 107, 107, 0.1);\n  color: #ff5252;\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .headerContent {\n    padding: 0.75rem 1rem;\n    min-height: 55px;\n  }\n\n  .headerTitle {\n    font-size: 1.125rem;\n  }\n\n  .welcomeText,\n  .roleText {\n    font-size: 0.8125rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .header {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n  }\n\n  .headerContent {\n    padding: 0.625rem 0.875rem;\n    min-height: 50px;\n    flex-wrap: nowrap;\n    gap: 0.5rem;\n  }\n\n  .headerLeft {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  .headerTitle {\n    font-size: 1rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .headerRight {\n    position: relative;\n    flex-shrink: 0;\n  }\n\n  .balancePill {\n    padding: 0.3rem 0.55rem;\n  }\n\n  .balanceLabel {\n    display: none;\n  }\n\n  .dropdown {\n    min-width: 180px;\n    right: 0;\n    max-width: calc(100vw - 1rem);\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .headerContent {\n    padding: 0.5rem 0.75rem;\n    min-height: 48px;\n  }\n\n  .headerTitle {\n    font-size: 1rem;\n  }\n\n  .profileButton {\n    padding: 0.25rem 0.375rem;\n  }\n\n  .profileIcon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .chevronIcon {\n    width: 14px;\n    height: 14px;\n  }\n\n  .balanceValue {\n    font-size: 0.8125rem;\n  }\n\n  .dropdown {\n    min-width: 160px;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Print styles */\n@media print {\n  .header {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__5xukw`,
	"headerContent": `Header_headerContent__BNPlQ`,
	"headerLeft": `Header_headerLeft__o3k6Y`,
	"headerTitle": `Header_headerTitle__u43YS`,
	"headerRight": `Header_headerRight__q1vdB`,
	"balancePill": `Header_balancePill__ayAwY`,
	"balanceLabel": `Header_balanceLabel__ToRBS`,
	"balanceValue": `Header_balanceValue__sWvBS`,
	"profileButton": `Header_profileButton__kp86u`,
	"profileIcon": `Header_profileIcon__8PZya`,
	"chevronIcon": `Header_chevronIcon__vlJcm`,
	"chevronOpen": `Header_chevronOpen__Agx-T`,
	"dropdown": `Header_dropdown__xchyz`,
	"slideDown": `Header_slideDown__tuS3-`,
	"dropdownHeader": `Header_dropdownHeader__13Tpc`,
	"dropdownWelcome": `Header_dropdownWelcome__8uW2T`,
	"dropdownRole": `Header_dropdownRole__eeGKi`,
	"dropdownDivider": `Header_dropdownDivider__0cGwh`,
	"logoutButton": `Header_logoutButton__A3+zb`,
	"welcomeText": `Header_welcomeText__rTzny`,
	"roleText": `Header_roleText__7IZvf`
};
export default ___CSS_LOADER_EXPORT___;
